export default __webpack_public_path__ + "static/media/no-email-found.dd9fc60f.svg";